export function isMac() {
  return /Mac|iPad/i.test(navigator.platform);
}
